/**
 * @file Download Photo Button Container.
 */

import compose from 'lodash.flowright';
import { withApollo } from 'react-apollo';

import DownloadPhotoButton from '../../components/global/DownloadPhotoButton';

export default compose(withApollo)(DownloadPhotoButton);
